// One delegated controller also handles sections reloaded by the theme editor.
(() => {
  const key = Symbol.for('keepr.measurementHelp');
  document[key]?.abort();
  const controller = new AbortController();
  document[key] = controller;

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const opener = target.closest('[data-keepr-measure-open]');
    if (opener) {
      // Preserve opening the full guide in another tab and the no-JS fallback.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog?.matches('[data-keepr-measure-dialog]') || !dialog.showModal) return;
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-keepr-measure-close]')?.focus();
      return;
    }

    const dialog = target.closest('[data-keepr-measure-dialog]');
    if (!dialog) return;
    if (target.closest('[data-keepr-measure-close], [data-keepr-builder-launch]')) {
      // Capture runs before the builder's delegated launch handler. Native close
      // releases the top layer and restores focus before the builder takes over.
      dialog.close();
      return;
    }
    const choice = target.closest('[data-measure-guide-choice]');
    if (!choice) return;
    const panelId = choice.getAttribute('aria-controls');
    const panels = [...dialog.querySelectorAll('[data-measure-guide-panel]')];
    if (!panels.some(panel => panel.id === panelId)) return;
    dialog.querySelectorAll('[data-measure-guide-choice]').forEach(button => {
      button.setAttribute('aria-pressed', String(button === choice));
    });
    panels.forEach(panel => { panel.hidden = panel.id !== panelId; });
  }, { capture: true, signal: controller.signal });
})();
